"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dompurify = _interopRequireDefault(require("dompurify"));

var _core = require("@material-ui/core");

var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _RadioGroup = _interopRequireDefault(require("@material-ui/core/RadioGroup"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));

var _LinearProgress = _interopRequireDefault(require("@material-ui/core/LinearProgress"));

var _moment = _interopRequireDefault(require("moment"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _FeedbackService = require("../../../KESI2/Services/FeedbackService");

var _strings = require("../Voting/strings");

var _BarChart = _interopRequireDefault(require("./BarChart"));

var _useTimer = require("./useTimer");

var _LiveTickerMessage = _interopRequireDefault(require("./LiveTickerMessage.scss"));

var _MiddleValue = _interopRequireDefault(require("./MiddleValue"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

function StyledRadioGroup(props) {
  var useRadioGroupStyles = (0, _core.makeStyles)(function (theme) {
    return {
      root: function root(props) {
        return {
          display: 'grid',
          gridAutoFlow: 'row',
          gridTemplateRows: "repeat(".concat(props.length, ", 1fr)"),
          gridTemplateColumns: '1fr',
          gap: '8px 8px',
          '@media (min-width:1023px)': {
            gridAutoFlow: 'column',
            gridTemplateColumns: "repeat(".concat(props.length, ", 1fr)"),
            gridTemplateRows: '1fr'
          }
        };
      }
    };
  });
  var answersLength = props.answersLength,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["answersLength"]);
  var classes = useRadioGroupStyles({
    length: answersLength
  });
  return /*#__PURE__*/_react["default"].createElement(_RadioGroup["default"], (0, _extends2["default"])({
    className: classes.root
  }, otherProps));
}

var StyledAnswerLabel = (0, _core.withStyles)(function (theme) {
  return {
    root: {
      margin: '0px',
      textAlign: 'left',
      flexDirection: 'row',
      '@media (min-width:1023px)': {
        textAlign: 'center',
        flexDirection: 'column'
      }
    }
  };
})(_FormControlLabel["default"]);

var LiveTickerLikertScaleQuestion = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(LiveTickerLikertScaleQuestion, _React$Component);

  var _super = _createSuper(LiveTickerLikertScaleQuestion);

  function LiveTickerLikertScaleQuestion(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, LiveTickerLikertScaleQuestion);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setSelectedAnswer", function (selectedAnswer) {
      _this.setState({
        selectedAnswer: selectedAnswer
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "sendFeedback", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var result;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _FeedbackService.pushFeedbackMessage)(_this.props.id, _this.state.selectedAnswer);

            case 2:
              result = _context.sent;

              _this.props.setTimer(0);

              _this.setState({
                votable: false
              });

              console.log(result);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    _this.state = {
      quotedMessage: null,
      selectedAnswer: '',
      votable: _this.props.active
    };
    return _this;
  }

  (0, _createClass2["default"])(LiveTickerLikertScaleQuestion, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.active !== this.props.active) {
        this.props.setTimer(0);
        this.setState({
          votable: this.props.active
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var message = _dompurify["default"].sanitize(this.props.message);

      var _this$state = this.state,
          selectedAnswer = _this$state.selectedAnswer,
          votable = _this$state.votable;
      var _this$props = this.props,
          data = _this$props.data,
          id = _this$props.id,
          completed = _this$props.completed;
      var answers = data.answers;
      return /*#__PURE__*/_react["default"].createElement(_core.Card, {
        className: _LiveTickerMessage["default"].outer,
        key: "entry_".concat(message.id),
        id: message.id,
        style: this.props.isHidden ? {
          padding: 0,
          margin: 0,
          maxHeight: 0
        } : {
          padding: '7px',
          margin: '10px 0',
          maxHeight: '9999px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_CardContent["default"], {
        style: {
          width: '20%',
          display: 'inline-block',
          verticalAlign: 'top',
          padding: 0
        }
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: _DeviceInfoHelper["default"].isBrowser() ? _LiveTickerMessage["default"].author : _LiveTickerMessage["default"].authorMobile,
        color: "textSecondary",
        gutterBottom: true
      }, this.props.author), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: _DeviceInfoHelper["default"].isBrowser() ? _LiveTickerMessage["default"].date : _LiveTickerMessage["default"].dateMobile,
        color: "textSecondary",
        gutterBottom: true
      }, (0, _moment["default"])(this.props.dateCreated).format('DD.MM.YYYY HH:mm'))), /*#__PURE__*/_react["default"].createElement(_CardContent["default"], {
        style: {
          width: '80%',
          display: 'inline-block',
          padding: 0,
          paddingLeft: 10,
          verticalAlign: 'top'
        }
      }, this.props.imageLink ? /*#__PURE__*/_react["default"].createElement("img", {
        style: {
          width: '100%',
          height: 'auto',
          display: 'block',
          position: 'relative',
          paddingBottom: '8px'
        },
        src: this.props.imageLink
      }) : null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: _DeviceInfoHelper["default"].isBrowser() ? _LiveTickerMessage["default"].message : _LiveTickerMessage["default"].messageMobile,
        color: "textSecondary",
        gutterBottom: true,
        dangerouslySetInnerHTML: {
          __html: message
        }
      }), /*#__PURE__*/_react["default"].createElement("div", null, votable ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          margin: '0 auto'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
        component: "fieldset"
      }, /*#__PURE__*/_react["default"].createElement(StyledRadioGroup, {
        answersLength: answers && answers.length,
        "aria-label": "vote",
        name: "vote",
        value: selectedAnswer,
        onChange: function onChange(e) {
          return _this2.setSelectedAnswer(e.target.value);
        }
      }, answers && answers.map(function (answer) {
        return /*#__PURE__*/_react["default"].createElement(StyledAnswerLabel, {
          key: answer.uuid,
          value: answer.uuid,
          control: /*#__PURE__*/_react["default"].createElement(_Radio["default"], null),
          label: answer.text
        });
      })))), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        variant: "contained",
        color: "primary",
        onClick: function onClick() {
          return _this2.sendFeedback();
        },
        style: {
          marginTop: '8px'
        }
      }, (0, _strings.getString)('VOTE_NOW')))) : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_MiddleValue["default"], {
        answerIds: answers.map(function (a) {
          return a.uuid;
        }),
        questionId: id
      }), /*#__PURE__*/_react["default"].createElement(_BarChart["default"], {
        title: 'Stimmen',
        categories: answers.map(function (answer) {
          return answer.text;
        }),
        answers: answers,
        id: id
      })))), completed !== 0 && /*#__PURE__*/_react["default"].createElement(_CardContent["default"], {
        style: {
          width: '100%',
          padding: '8px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_LinearProgress["default"], {
        variant: "determinate",
        value: completed
      })));
    }
  }]);
  return LiveTickerLikertScaleQuestion;
}(_react["default"].Component);

LiveTickerLikertScaleQuestion.propTypes = {
  id: _propTypes["default"].string,
  userId: _propTypes["default"].string,
  key: _propTypes["default"].string,
  message: _propTypes["default"].string,
  dateCreated: _propTypes["default"].string,
  dateEdited: _propTypes["default"].string,
  isLatest: _propTypes["default"].bool,
  author: _propTypes["default"].string,
  imageLink: _propTypes["default"].string,
  isHidden: _propTypes["default"].bool,
  data: _propTypes["default"].object,
  duration: _propTypes["default"].string,
  setTimer: _propTypes["default"].func,
  completed: _propTypes["default"].number,
  active: _propTypes["default"].bool
};
LiveTickerLikertScaleQuestion.defaultProps = {
  isLatest: false,
  isExpert: false
};

var _default = (0, _useTimer.withTimer)(LiveTickerLikertScaleQuestion);

exports["default"] = _default;